import ServicePage from "./page";
import { marineInsuranceData } from "@/mocks/insurancePages";

export default function MarineInsurance() {
  return <ServicePage data={marineInsuranceData} />;
}